type CampaignStatCardProps = {
  title: string;
  value: React.ReactNode;
};

const CampaignStatCard: React.FC<CampaignStatCardProps> = ({title, value}) => {
  return (
    <article className="flex min-w-0 flex-col gap-2.5 rounded-lg bg-gray-02 p-3">
      <span className="text-body-sm text-gray-08">{title}</span>
      <span className="text-subtitle-lg text-neutral-fg">{value}</span>
    </article>
  );
};

export default CampaignStatCard;
